import { DateTime } from 'luxon'
import React from 'react'
import { ReactComponent as Check } from "../../../assets/new-icons/check_simple.svg";

function BarContainer(props) {
    const {datamisura, kwh_tot, spesa_giorno, tipo} = props.data;
    const heightKwh = `${kwh_tot / props.maxValue * 100}%`
    const heightEuro = `${spesa_giorno / props.maxEuro * 100}%`
    const range1 = props.avarageKwh + 3
    const range2 = props.avarageKwh
    return (
        
        <div className="week_graph-container">
            <div className="week_graph-bar" style={props.switchEuro ? {height: heightEuro} : {height: heightKwh}}>
                {tipo === 'R' ? (
                    <Check fill='#6610f2'/>
                ) : null}
            </div>
            <div className="week_graph-avarage" style={kwh_tot > range1 ? {background: 'red'} : kwh_tot < range2 ? {background: 'green'} : {background: 'orange'}}></div>
            <div className="week_graph-day">
                <p>{DateTime.fromISO(datamisura).toFormat('EEE')}</p>
            </div>
        </div>
    )
}

export default BarContainer